import { getAuth, getIdToken, User } from "firebase/auth";
import axios, { AxiosInstance } from "axios";

let instance: AxiosInstance | undefined = undefined;

export const propelyApi = () => {
  const propelyApiUrl = process.env.REACT_APP_API_URL;
  if (instance) return instance;
  instance = axios.create({
    baseURL: propelyApiUrl,
  });

  // Add an interceptor to add the token to the request
  instance.interceptors.request.use(async (config) => {
    const auth = getAuth();
    let user: User | null = auth.currentUser;

    // If user is not fetched / initialized yet, we wait for it
    if (!user) {
      user = await new Promise((resolve) => {
        const unsubscribe = auth.onAuthStateChanged((user) => {
          unsubscribe(); // Cleanup subscription
          resolve(user);
        });
      });
    }

    if (!user) {
      return config;
    }
    const token = await getIdToken(user, false);
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  });

  return instance;
};

export const resetPropelyApi = () => {
  console.log("Resetting propelyApi");
  instance = undefined;
};
